import Ajax from '@lib/ajax'

export default {
  async createEdit(payload){
    return Ajax.post('/api/services/app/MediaGallery/CreateEdit',payload);
  },
  async create(payload){
    return Ajax.post('/api/services/app/MediaGallery/Create',payload.data);
  },
  async update(payload){
    return Ajax.put('/api/services/app/MediaGallery/Update',payload.data);
  },
  async delete(id){
    return Ajax.delete('/api/services/app/MediaGallery/DeleteAsync?Id=' +id);
  },
  async get(id){
    return Ajax.get('/api/services/app/MediaGallery/Get?Id='+ id);
  },
  async getGallery(id){
    return Ajax.get('/api/services/app/MediaGallery/GetGallery?Id='+id);
  },
  async getAll(payload){
    return Ajax.get('/api/services/app/MediaGallery/GetAll',{params:payload.data});
  },
  async getGalleryGridResult(payload){
    return Ajax.get('/api/services/app/MediaGallery/GetGalleryGridResult', payload);
  },
  async deleteMediaItemByUID(uid){
    return Ajax.delete('/api/services/app/MediaGallery/DeleteMediaItemByUID?uid='+uid);
  },
}